'use client';

import { getAccessToken } from '@/src/lib/auth/business/get-access-token';
import { isFailure } from '@/src/lib/http/business/server-action-results';
import { User } from '@auth0/nextjs-auth0/types';
import useSWR from 'swr';

// NOTE: This is a workaround for this issue:
// https://github.com/auth0/nextjs-auth0/issues/1933
// SWR loses basic auth credentials when making a request to /auth/profile
export function useUser() {
  const {
    data,
    error,
    isLoading
  } = useSWR<User, Error, string>(process.env.NEXT_PUBLIC_PROFILE_ROUTE || '/auth/profile', async (...args) => {
    try {
      const authToken = await getAccessToken();
      if (isFailure(authToken)) {
        throw new Error('Unauthorized');
      }
      return fetch(...args).then(res => {
        if (!res.ok) {
          throw new Error('Unauthorized');
        }
        return res.json();
      });
    } catch (_) {}
  });

  // if we have the user loaded via the provider, return it
  if (data) {
    return {
      user: data,
      isLoading: false,
      error: null
    };
  }
  if (error) {
    return {
      user: null,
      isLoading: false,
      error
    };
  }
  return {
    user: data,
    isLoading,
    error
  };
}